import { MailOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row } from "antd";
import React, { useCallback, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as actions from "../../actions";

import { logTMDataLayer } from "../../hooks/useLogTMDataLayer";
import { State } from "../../interfaces";
import { AuthState } from "../../reducers/auth";
import { LanguageState } from "../../reducers/language";
import { encrypt } from "../../utils";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 24 }
};

interface Props {
  location: Object;
}

const ForgotPasswordPage: React.FC<Props> = (props) => {
  const auth: AuthState = useSelector(
    (state: State) => state.auth,
    shallowEqual
  );
  const { user, isFetching } = auth;

  const language: LanguageState = useSelector(
    (state: State) => state.language,
    shallowEqual
  );
  const { labels } = language;

  useEffect(() => {
    logTMDataLayer({
      dataLayer: {
        event: "init",
        userId: user?.email ? encrypt(user?.email as string) : undefined,
        user_type: user?.role?.[0],
        pageType: "forgotpassword",
        language: language.selectedLanguage?.id,
        country: undefined,
        loginStatus: !!user ? "Logged" : "Guest"
      },
      dataLayerName: "dataLayer"
    });
  }, [user, language.selectedLanguage]);

  const dispatch = useDispatch();

  const onRecoverPassword = useCallback(
    (userName, email) => dispatch(actions.recoverPassword(userName, email)),
    [dispatch]
  );

  const onFinish = (values: any) => {
    console.log("Success:", values);
    const { userName, email } = values;
    onRecoverPassword(userName, email);
  };

  return (
    <Row className="login" align="middle">
      <Col xs={{ span: 22, offset: 1 }} sm={{ span: 8, offset: 8 }}>
        {labels && (
          <Form {...layout} onFinish={onFinish} className="login-form">
            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  message: `${labels.notValidMail}`
                },
                {
                  required: true,
                  message: `${labels.requiredFiels}`
                }
              ]}
            >
              <Input
                prefix={<MailOutlined style={{ fontSize: 13 }} />}
                placeholder="E-mail"
              />
            </Form.Item>
            <Form.Item>
              <Link className="login-form-forgot" to="/">
                Back to Login
              </Link>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={isFetching}
              >
                {labels.recoverPassword}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Col>
    </Row>
  );
};

export default ForgotPasswordPage;
